import createIcon from '../../createIcon';

/**
 * @component @name FormatItalic
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgNVY4SDEyLjIxTDguNzkgMTZINlYxOUgxNFYxNkgxMS43OUwxNS4yMSA4SDE4VjVIMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatItalic = createIcon('FormatItalic', [
  ['path', { d: 'M10 5V8H12.21L8.79 16H6V19H14V16H11.79L15.21 8H18V5H10Z', key: '801zi6' }],
]);

export default FormatItalic;
